import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const ProjectManagementRoutes = ({ DetailReport }: { DetailReport: React.ComponentType }) => (
  <Routes>
    <Route path={ROUTES.PROJECT_MANAGEMENT.REPORT_DETAIL.BASE} element={<DetailReport />} />
  </Routes>
);
